module.exports = __webpack_public_path__ + "static/img/midi.8003f84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/midi.png
// module id = punw
// module chunks = 53